<template>
  <el-main class="container">
    <el-form
      label-position="top"
      label-width="80px">
      <div class="title" v-if="type === 'set'">编辑服务企业</div>
      <div class="title" v-else>新增服务企业</div>
      <el-form-item label="排序序号">
        <el-input
          placeholder="请输入排序序号"
          v-model.trim="body.indexNum"
          @mousewheel.native.prevent
          clearable
          class="width"
          type="number"
          maxlength="100"/>
      </el-form-item>
      <el-form-item label="企业名称">
        <el-input
          placeholder="请输入企业名称"
          v-model.trim="body.name"
          clearable
          class="width"
          type="text"/>
      </el-form-item>
      <div class="row">
        <div class="el-form-item el-form-item--medium" style="margin-right: 60px">
          <div class="el-form-item__label">所属产业</div>
          <div class="el-form-item__content">
            <el-select v-model="selectIndustry" @change="handleIndustry" clearable placeholder="请选择产业" class="width">
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <el-form-item label="分类">
          <el-select
            class="width"
            v-model="selectClassify"
            placeholder="请选择分类"
            @change="event().selectClassify($event)">
            <el-option
              v-for="(item,index) in classifyList"
              :key="index"
              :value="item.name"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="简介">
        <el-input
          placeholder="请输入简介"
          type="textarea"
          class="text"
          maxlength="100"
          show-word-limit
          v-model="body.briefIntroduction"
          :autosize="{ minRows: 8, maxRows: 99 }"/>
      </el-form-item>
      <el-form-item :label="pictureTitle">
        <UpLoadImg
          tips="(180*180)"
          :img="picture"
          :size="[350, 180]"
          @get-files="getFiles"/>
      </el-form-item>
      <el-form-item :label="bannersTitle">
        <UpLoadImg
          tips="(686*320)"
          :img="banners"
          :length="6"
          :size="[640,640]"
          @get-files="getbanner"/>
      </el-form-item>
      <div class="title">介绍</div>
      <wang-editor
        ref="editor"
        @editorContent="getEditorContent"/>
    </el-form>
    <div class="btn-box">
      <el-button @click="event().back()">取消</el-button>
      <el-button type="primary" @click="event().save()">保存</el-button>
    </div>
  </el-main>
</template>

<script>
import UpLoadImg from '@/components/upload-img'
import WangEditor from '@/components/Wangeditor/index'
import { updateCompanyServe, addCompanyServe, getServeDetails, getServerList } from '@/api/serve'
import { getIndustrySelectList } from '@/api/industry'
export default {
  data() {
    return {
      body: {
        briefIntroduction: '',
        indexNum: '',
        introduction: '',
        name: '',
        picture: '',
        typeUuid: '',
        banners: []
      },
      type: [],
      info: {

      },
      picture: '',
      pictureTitle: '企业logo(0/1)',
      banners: [],
      bannersTitle: '轮播图(0/6)',
      classifyList: [], // 分类
      selectClassify: '', // 选择分类
      industryList: [],
      selectIndustry: ''
    }
  },
  created() {
    const { meta } = this.$route
    this.type = meta[meta.length - 1].url
    this.network().getIndustrySelectList()
  },
  mounted() {
    if (this.type === 'set') {
      this.$nextTick(() => {
        this.network().getServeDetails()
      })
    }
    // this.network().getServerList()
  },
  methods: {
    // 获取编辑器内容
    getEditorContent(data) {
      this.body.introduction = data
    },
    event() {
      return {
        back: () => {
          this.$router.push('/serve-management/serve-management-management')
        },
        save: () => {
          if (!this.handlerVarifyBody()) return
          if (this.type === 'set') {
            delete this.body.type
            this.network().updateCompanyServe()
          } else if (this.type === 'add') {
            this.network().addCompanyServe()
          }
        },
        selectClassify: (e) => {
          this.classifyList.forEach(item => {
            if (item.name === this.selectClassify) {
              this.body.typeUuid = item.uuid
            }
          })
        }
      }
    },
    network() {
      return {
        updateCompanyServe: async() => {
          await updateCompanyServe(this.body)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.event().back()
        },
        addCompanyServe: async() => {
          await addCompanyServe(this.body)
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.event().back()
        },
        getServeDetails: async() => {
          const { data } = await getServeDetails(this.$route.params.id)
          this.selectIndustry = data.industryUuid
          this.body = data
          this.picture = data.picture
          this.banners = data.banners
          this.$refs.editor.setHtml(data.introduction)
          this.picture ? this.pictureTitle = '企业logo(1/1)' : this.pictureTitle = '企业logo(0/1)'
          this.bannersTitle = `轮播图(${this.banners.length}/6)`
          this.selectClassify = data.type.name
          this.body.typeUuid = data.type.uuid
          this.network().getServerList(data.industryUuid)
        },
        getServerList: async(id) => {
          const { data } = await getServerList(id)
          this.classifyList = data
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handlerVarifyBody() {
      if (!this.body.indexNum) {
        this.$message({
          message: '请填写排序序号',
          type: 'warning'
        })
        return false
      }
      if (!this.body.name) {
        this.$message({
          message: '请填写企业名称',
          type: 'warning'
        })
        return false
      }
      if (this.selectIndustry === '') {
        this.$message({
          message: '请选择产业',
          type: 'warning'
        })
        return false
      }
      if (!this.selectClassify) {
        this.$message({
          message: '请选择分类',
          type: 'warning'
        })
        return false
      }
      if (!this.body.briefIntroduction) {
        this.$message({
          message: '请填写简介',
          type: 'warning'
        })
        return false
      }
      if (!this.body.picture) {
        this.$message({
          message: '请上传企业logo',
          type: 'warning'
        })
        return false
      }
      if (this.body.banners.length === 0) {
        this.$message({
          message: '请上传轮播图',
          type: 'warning'
        })
        return false
      }
      if (this.body.introduction === '' || this.body.introduction === '<p><br></p>') {
        this.$message({
          message: '请填写介绍',
          type: 'warning'
        })
        return false
      }
      return true
    },
    getFiles(file, files) {
      this.body.picture = files.length ? file.response : ''
      files.length ? this.pictureTitle = '企业logo(1/1)' : this.pictureTitle = '企业logo(0/1)'
    },
    getbanner(file, files) {
      // console.log(file,files);
      const arr = []
      files.forEach((item) => {
        if (item.response === undefined) {
          arr.push(item.url.substring(item.url.lastIndexOf('/') + 1))
        } else {
          arr.push(item.response)
        }
      })
      this.body.banners = arr
      this.bannersTitle = `轮播图(${arr.length}/6)`
    },
    handleIndustry() {
      debugger
      if (this.selectIndustry !== this.body.industryUuid) {
        this.body.typeUuid = ''
        this.selectClassify = ''
      }
      if (this.selectIndustry !== '') {
        this.network().getServerList(this.selectIndustry)
      }
    }
  },
  components: {
    UpLoadImg,
    WangEditor
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-weight: bold;
    margin: 15px 0;
    font-size: 20px
  }
  .btn-box{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    button{
      margin: 0 15px;
    }
  }
  .width{
    width: 500px;
  }
  .row{
    display: flex;
  }
}
</style>
